/**
 * SENTRY-FIX-002: Global Fetch Error Handler
 * Resolves: SYRS-SHOPIFY-12 (TypeError: Failed to fetch)
 */

(function() {
  'use strict';

  const FETCH_CONFIG = {
    maxRetries: 3,
    timeout: 10000,
    retryDelay: 1000,
    retryableStatuses: [408, 429, 500, 502, 503, 504],
    logErrors: true
  };

  window.fetchWithRetry = async function(url, options) {
    options = options || {};
    const config = Object.assign({}, FETCH_CONFIG, options.fetchConfig || {});
    let lastError = null;

    for (let attempt = 0; attempt < config.maxRetries; attempt++) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(function() { controller.abort(); }, config.timeout);

        const fetchOptions = Object.assign({}, options, {
          signal: controller.signal
        });

        const response = await fetch(url, fetchOptions);
        clearTimeout(timeoutId);

        if (!response.ok) {
          if (config.retryableStatuses.indexOf(response.status) !== -1 && attempt < config.maxRetries - 1) {
            const delay = config.retryDelay * Math.pow(2, attempt);
            console.warn('[SENTRY-FIX-002] Fetch attempt ' + (attempt + 1) + ' failed with status ' + response.status + '. Retrying in ' + delay + 'ms...');
            await new Promise(function(resolve) { setTimeout(resolve, delay); });
            continue;
          }

          throw new Error('HTTP ' + response.status + ': ' + response.statusText);
        }

        if (config.logErrors && attempt > 0) {
          console.log('[SENTRY-FIX-002] Fetch succeeded on attempt ' + (attempt + 1));
        }

        return response;

      } catch (error) {
        lastError = error;

        if (error.name === 'AbortError') {
          console.warn('[SENTRY-FIX-002] Fetch timeout after ' + config.timeout + 'ms (attempt ' + (attempt + 1) + ')');
        } else if (error.message.indexOf('Failed to fetch') !== -1 || error.message.indexOf('NetworkError') !== -1) {
          console.warn('[SENTRY-FIX-002] Network error on attempt ' + (attempt + 1) + ': ' + error.message);
        } else {
          console.warn('[SENTRY-FIX-002] Fetch error on attempt ' + (attempt + 1) + ':', error);
        }

        if (attempt < config.maxRetries - 1) {
          const delay = config.retryDelay * Math.pow(2, attempt);
          await new Promise(function(resolve) { setTimeout(resolve, delay); });
        }
      }
    }

    console.error('[SENTRY-FIX-002] All ' + config.maxRetries + ' fetch attempts failed for: ' + url);
    
    if (window.Sentry && window.Sentry.captureException) {
      window.Sentry.captureException(lastError, {
        tags: {
          url: url,
          maxRetries: config.maxRetries,
          fix: 'SENTRY-FIX-002'
        }
      });
    }

    throw lastError;
  };

  window.fetchJSON = async function(url, options) {
    try {
      const response = await window.fetchWithRetry(url, options);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('[SENTRY-FIX-002] Failed to fetch and parse JSON:', error);
      throw error;
    }
  };

  window.safeFetch = async function(url, options) {
    try {
      return await window.fetchWithRetry(url, options);
    } catch (error) {
      console.warn('[SENTRY-FIX-002] Safe fetch failed, returning null:', error);
      return null;
    }
  };

  console.log('[SENTRY-FIX-002] Fetch error handler initialized');
})();
